<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


$(document).ready(function(){
    if($(document).find('.quantity__input').length){
        var get_min = $(document).find('.quantity__input').attr('min');
        if(get_min != ''){
          $('.quantity__input').val(get_min);
        }
    }
    var maxHeight = 0;
    $('.collection-sub-list .item a span').each(function() {
        $(".collection-sub-list .item a span").css("height","auto");
        if ($(this).height() > maxHeight) {
          maxHeight = $(this).height();
        }
    });
    $('.collection-sub-list .item a span').height(maxHeight);
});
$(window).resize(function(){
    $(".collection-sub-list .item a span").css("height","auto");
    var maxHeight = 0;
    $('.collection-sub-list .item a span').each(function() {
        if ($(this).height() > maxHeight) {
          maxHeight = $(this).height();
        }
    });
    $('.collection-sub-list .item a span').height(maxHeight);
});